module.exports = __webpack_public_path__ + "static/media/canada.994f9ce7.png";